import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CourseBackgroundImageService {

  constructor() { }

  getCourseCardBackground(courseName: string): string {
    switch (courseName) {
      case 'PSM I':
        return '/assets/img/PSM.jpg';
      case 'PSM II':
        return '/assets/img/PSM_Bild.jpg';
      case 'PSPO I':
        return '/assets/img/PSPO.jpg';
      case 'PSPO II':
        return '/assets/img/PSPO_Bild.jpg';
      case 'SPS':
        return '/assets/img/SPS.jpg';
      case 'PSK':
        return '/assets/img/PSK.jpg';
      case 'PAL':
        return '/assets/img/PAL.jpg';
      case 'Agile Leader':
        return '/assets/img/Agile_Leader.jpg';
      default:
        return '/assets/img/exam-card-cover.jpg';
    }
  }
}
